export default "__VITE_ASSET__BlZEzRvM__"